/** @jsxImportSource @emotion/react */

import React, { useEffect, useRef } from 'react';

import styled from '@emotion/styled';

import { media } from '../../services/media';

import { ModuleComponents } from '../ModuleComponents';
import { Wrapped } from '../../hocs/withRenderSettings';
import { useStoreData } from '../../hooks';

interface FooterProps {
    setHeight: React.Dispatch<React.SetStateAction<number>>;
}

export const Footer = ({ setHeight }: FooterProps) => {
    const footerData = useStoreData().storyblok.FooterItem;
    const ref = useRef<HTMLHeadElement>(null);

    useEffect(() => {
        setHeight(ref.current?.clientHeight || 0);
    }, [ref]);

    if (!footerData) {
        return null;
    }

    const { renderSettings, components } = footerData.content;

    return (
        <Wrapped
            renderAs={StyledFooter}
            renderSettings={renderSettings}
            ref={ref}
        >
            <ModuleComponents components={components} />
        </Wrapped>
    );
};

const StyledFooter = styled.footer`
    position: relative;
    background-repeat: no-repeat;
    background-position: 57% 0;
    background-size: cover;

    ${media.max('md')} {
        padding: 40px 0;
    }

    ${media.min('md')} {
        padding: 80px 0;
    }
`;
